/** API route map: URLS.Controller.W2FormCustomSection */
export const W2FormCustomSection = {
      Name: 'W2FormCustomSection/',
      AddW2CustomSection: 'add-w2-custom-section',
      AddW2CustomSectionField: 'add-w2-custom-section-field',
      UpdateW2CustomSection: 'update-w2-custom-section',
      UpdateW2CustomSectionField: 'update-w2-custom-section-field',
      GetW2CustomSection: 'get-w2-custom-section',
      DeleteSection: 'delete-w2-custom-section',
      DeleteSectionField: 'delete-w2-custom-section-field',
      UpdateW2CustomSectionList: 'update-w2-custom-section-list',
      UpdateW2CustomSectionFieldList: 'update-w2-custom-section-field-list',
      GetAllW2FormField: 'get-all-w2-form-field',
      ReleteReferenceCheckQuestionnaire: 'delete-reference-check-questionnaire',
};
